// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"57":"page-mypage-contracts","696":"auth-login","763":"page-mypage-dashboard","773":"layout-app","948":"page-admin-dashboard"}[chunkId] + "." + {"57":"9169ca04","696":"52f4d1c5","763":"73ec5bea","773":"baa72c06","948":"8da42611"}[chunkId] + ".js";
};